import { ProtoSpriteThree } from "protosprite-three";
import { useMemo } from "react";
import { Box3, OrthographicCamera, Vector3 } from "three";

import { SceneAndCamera } from "../SecondaryRenderer";

export function useProtospriteScene<
  TL extends string = string,
  TT extends string = string
>(sprite: ProtoSpriteThree<TL, TT> | null, animationName: TT): SceneAndCamera {
  return useMemo(() => {
    if (!sprite) return { scene: null, camera: null };

    sprite.gotoAnimation(animationName);
    sprite.gotoAnimationFrame(0);
    sprite.center();

    const camera = new OrthographicCamera();

    fitCameraToSprite(camera, sprite);

    return { scene: sprite.mesh, camera };
  }, [sprite, animationName]);
}

function fitCameraToSprite(
  camera: OrthographicCamera,
  sprite: ProtoSpriteThree
) {
  camera.position.set(0, 0, 1);
  camera.lookAt(new Vector3());
  const bbox = new Box3();
  bbox.expandByObject(sprite.mesh);
  camera.left = bbox.min.x;
  camera.right = bbox.max.x;
  camera.top = bbox.min.y;
  camera.bottom = bbox.max.y;
  camera.updateProjectionMatrix();
}
